export const settingsConstants = {
  LOAD: 'settings/LOAD',
  LOAD_SUCCESS: 'settings/LOAD_SUCCESS',
  LOAD_FAIL: 'settings/LOAD_FAIL',
  LOAD_SETTINGS: 'settings/LOAD_SETTINGS',
};
